<div class="reset-page">
    <div class="reset-hero" style="background-image: url('assets/img/hero/console.png')">
        <div class="reset-overlay">
            <div class="reset-left">
                <h1>Reset Your Password</h1>
                <p>Secure your YoGamez Hub account</p>
            </div>
            <div class="reset-card">
                <h2>Reset Password</h2>
                <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
                    <label>Phone Number</label>
                    <span *ngIf="resetForm.get('identifier')?.invalid && resetForm.get('identifier')?.touched"
                          class="error-text">
                        Identifier is required
                    </span>
                    <span *ngIf="resetForm.get('identifier')?.errors?.['isEconetSubscriber'] && resetForm.get('identifier')?.touched && resetForm.get('identifier')?.value!=''"
                          class="error-text">
                        Invalid Econet number. It must start with 077, 078, or 079 and have 10 digits.
                    </span>
                    <div class="input__item">
                        <span class="fa fa-user"></span>
                        <input type="text" placeholder="Phone number 07.." formControlName="identifier" maxlength="10">
                    </div>

                    <label>New Password</label>
                    <span *ngIf="resetForm.get('password')?.invalid && resetForm.get('password')?.touched" class="error-text">
                        Password is required
                    </span>
                    <span *ngIf="resetForm.get('password')?.hasError('minlength') && resetForm.get('password')?.touched"
                          class="error-text">
                        Password must be at least 6 characters long
                    </span>
                    <div class="input__item">
                        <span class="fa fa-lock"></span>
                        <input [type]="isPasswordVisible ? 'text' : 'password'" placeholder="New Password" formControlName="password">
                        <button class="toggle-password-btn" type="button" (click)="togglePasswordVisibility()">
                            <i *ngIf="isPasswordVisible" class="fa fa-eye-slash"></i>
                            <i *ngIf="!isPasswordVisible" class="fa fa-eye"></i>
                        </button>
                    </div>

                    <label>Confirm Password</label>
                    <span *ngIf="resetForm.get('confpassword')?.invalid && resetForm.get('confpassword')?.touched" class="error-text">
                        Password is required
                    </span>
                    <div class="input__item">
                        <span class="fa fa-lock"></span>
                        <input [type]="isPasswordVisible ? 'text' : 'password'" placeholder="Confirm Password" formControlName="confpassword">
                        <button class="toggle-password-btn" type="button" (click)="togglePasswordVisibility()">
                            <i *ngIf="isPasswordVisible" class="fa fa-eye-slash"></i>
                            <i *ngIf="!isPasswordVisible" class="fa fa-eye"></i>
                        </button>
                    </div>

                    <div *ngIf="isVerified">
                        <label>OTP</label>
                        <span *ngIf="resetForm.get('resetOtp')?.invalid && resetForm.get('resetOtp')?.touched" class="error-text">
                            OTP is required
                        </span>
                        <div class="input__item">
                            <span class="fa fa-keyboard-o"></span>
                            <input type="text" placeholder="OTP" formControlName="resetOtp">
                            <button class="otp-password-btn" type="button" title="Resend OTP" (click)="getOTP()">
                                <i class="fa fa-refresh"></i>
                            </button>
                        </div>
                    </div>

                    <span *ngIf="!isVerified && noPhone" class="error-text">
                        *Provide valid phone number to get OTP
                    </span>

                    <div class="reset-actions">
                        <button *ngIf="!isVerified" type="button" class="site-btn" (click)="getOTP()">Get OTP</button>
                        <button *ngIf="isVerified" type="submit" class="site-btn">Reset</button>
                        <p>Have an account? <a (click)="routeToPage('/login')">Sign In!</a></p>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
